import { assign, entryId } from "../../helper.js";
import { isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/tableGroup.entity.js
var createTableGroup = () => ({
	id: "",
	name: "",
	color: "",
	ui: {
		x: 200,
		y: 100,
		width: 400,
		height: 300,
		zIndex: 1
	}
});
function createAndMergeTableGroupEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createTableGroup();
		const assignString = assign(isString, target, value);
		const uiAssignNumber = assign(isNumber, target.ui, value.ui);
		target.id = entryId(key, value);
		assignString("name");
		assignString("color");
		uiAssignNumber("x");
		uiAssignNumber("y");
		uiAssignNumber("width");
		uiAssignNumber("height");
		uiAssignNumber("zIndex");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeTableGroupEntities, createTableGroup };
